import { FC } from "react";
import { compareAsc, format } from "date-fns";
import {
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import __ from "src/utils/Translations";
import { IExcludedDay } from "src/Pages/Company/Absences/Calendars/Calendars.models";

interface ICalendarLegendProps {
  excludedDays: IExcludedDay[];
}

const sortByDate = (a: IExcludedDay, b: IExcludedDay): number =>
  compareAsc(new Date(a.date), new Date(b.date));

const CalendarLegend: FC<ICalendarLegendProps> = ({ excludedDays = [] }) => {
  const sortedDays = [...excludedDays].sort(sortByDate);

  return (
    <>
      <Divider
        sx={{
          marginBottom: "2rem",
        }}
      />
      <Table sx={{ minWidth: 500 }} data-testid="absences-calendar-legend">
        <TableHead>
          <TableRow>
            <TableCell
              sx={{
                color: "primary.main",
                borderBottom: "none",
                padding: "0.5rem",
              }}
            >
              {__("Nazwa")}
            </TableCell>
            <TableCell
              sx={{
                color: "primary.main",
                borderBottom: "none",
                padding: "0.5rem",
              }}
            >
              {__("Data")}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedDays.map((day) => (
            <>
              {day.label && (
                <TableRow data-testid="absences-calendar-legend__item">
                  <TableCell
                    sx={{
                      borderBottom: "none",
                      padding: "0.5rem",
                    }}
                  >
                    {day.label}
                  </TableCell>
                  <TableCell
                    sx={{
                      borderBottom: "none",
                      padding: "0.5rem",
                    }}
                  >
                    {format(new Date(day.date), "dd.MM.yyyy")}
                  </TableCell>
                </TableRow>
              )}
            </>
          ))}
        </TableBody>
      </Table>
    </>
  );
};

export default CalendarLegend;
